import { render, staticRenderFns } from "./NoisePollution.vue?vue&type=template&id=7481b871"
import script from "./NoisePollution.vue?vue&type=script&setup=true&lang=js"
export * from "./NoisePollution.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports